
import { defineComponent } from 'vue';
import PrzLikes from '@/components/Muffin/Like.vue';
import { BlockEvents } from '@/models/Blocks/block-events';

export default defineComponent({
    components:{
        PrzLikes
    },
    props: {
        showNumber: {
            type: Boolean,
            default: true
        },
        likes: {
            type: Number,
            default: 0
        },
        info: {
            type: Object,
            default: () => {
                return {
                    itemId: null,
                    type: null,
                    liked: false
                }
            }
        },
    },
    mounted(){
        BlockEvents.AddSocialLikeListener((id: string, liked: boolean) => {
            if(id == this.info.itemId){
                this.$emit('change',{itemId: id, liked: liked});
            }
        });
    },
    methods:{
        change(info: any){
            BlockEvents.AddSocialLikeAction(info);
        },

    }
});
